import React, { useEffect, useRef, useState } from "react";
import { faAngleLeft, faAngleRight, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AllProductsPagination, AllRfqPagination, AscendingOrder, DecendingOrder, GetAndCreateRfq } from "../../../../services/ProductService/AllProductList/AllProductServices";
import TableActionPopUp from "./TableActionPopUp";
import SingleRfqView from "./Rfq Modals/SingleRfqView";
import ServiceBuyerData from "../../../../utils/AllServicesData/ServicesBuyerData/ServiceBuyerData";

export default function AllRfqTable({ onRfqSelectColumns, onRfqSelectedIds, onSuccess, onRfqColumnSearch, onRefresh, onPageSize,onReturnPageSize, onUpdate, onChangeIcon }) {
    const [allRfqList, setAllRfqList] = useState([]);
    const [filteredRfqList, setFilteredRfqList] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedIds, setRfqSelectedIds] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
    const [searchTerms, setSearchTerms] = useState({});
    const popupRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const [nextPageLink, setNextPageLink] = useState(null);
    const [previousPageLink, setPreviousPageLink] = useState(null);
    const [pageSize, setPageSize] = useState(20);

    const columnKeyMap = {
        'Buyer / Seller': 'email',
        'Company Name': 'company_name',
        'Preferred Source Country': 'preferred_source_country',
        'Wanted': 'product_name',
        'Mobile No': 'mobile_number',
        'Short Description': 'short_description',
        'Product HSN Code': 'hsn_code',
        'Quantity': 'quantity',
        'Unit': 'unit',
        'Destination Port': 'destination_port',
        'Income Term': 'inco_term',
        'Payment Term': 'payment_term',
        'Target Price': 'target_price',
        'Negotiable': 'is_negotiable',
        'Attachement': 'attachment',
    };

    const defaultVisibleColumns = [
        'Buyer / Seller',
        'Company Name',
        'Preferred Source Country',
        'Wanted',
        'Mobile No',
        'Short Description'
    ];  

    const getAllRfqList = async () => {
        setLoading(true);
        try {
            // const response = await GetAndCreateRfq('GET', {});           
            // setAllRfqList(response.data.results);
            // setFilteredRfqList(response.data.results);
            // setNextPageLink(response.data.links.next);
            // setPreviousPageLink(response.data.links.previous);
            setAllRfqList(ServiceBuyerData.results)
            setFilteredRfqList(ServiceBuyerData.results)
        } catch (error) {
            console.error("Error fetching product list:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setShowPopup(false);
        }
    };

    const handleIconClick = (id, event) => {
        event.stopPropagation();
        const rect = event.currentTarget.getBoundingClientRect(); // Get icon's position

        setPopupPosition({
            x: rect.left - 100, // Adjust the left position to be on the left side of the icon
            y: rect.top + 10 + window.scrollY // Adjust for any scroll position
        });

        setSelectedId(id);
        setShowPopup(true);
    };

    const [selectedSingleRfq,setSelectedSingleRfq] = useState(null)
    const [showSingleRfq,setShowSingleRfq] = useState(false)

    const handleRfqClick = (id) => {
        if (id) {
           setSelectedSingleRfq(id)
           setShowSingleRfq(true)
        }
    }

    const handleRfqSuccess = () =>{
        getAllRfqList()
    }

    const handleViewSingleRfq =(id) =>{
        setSelectedSingleRfq(id)
        setShowSingleRfq(true)
    }

    const handleSelectAll = () => {
        if (selectedIds.length === filteredRfqList.length) {
            // If all filtered items are selected, deselect all
            setRfqSelectedIds([]);
        } else {
            // Select all visible (filtered) products
            setRfqSelectedIds(filteredRfqList.map(item => item.id));
        }
    };

    // ✅ Pass selected Ids to parent and close modal
    if (selectedIds.length >= 0) {
        if (typeof onRfqSelectedIds === "function") {
            onRfqSelectedIds(selectedIds); // Pass data up
        }
    };

    const handleSelectItem = (id) => {
        setRfqSelectedIds((prevSelectedIds) =>
            prevSelectedIds.includes(id)
                ? prevSelectedIds.filter((selectedId) => selectedId !== id) // Deselect
                : [...prevSelectedIds, id] // Select    
        );
    };

    const handleSearch = (col, value) => {
        const updatedSearchTerms = { ...searchTerms, [col]: value };
        setSearchTerms(updatedSearchTerms);

        // Filter logic
        const filtered = allRfqList.filter(item =>
            visibleColumns.every(col => {
                const searchTerm = updatedSearchTerms[col]?.toString().toLowerCase();
                const value = item[columnKeyMap[col]]?.toString().toLowerCase();
                return !searchTerm || (value && value.includes(searchTerm));
            })
        );
        setFilteredRfqList(filtered);
    };

    const onRfqSearchColumn = (input) => {  
        // Reset to full list if input is empty
        const trimmedInput = input.trim();
        if (trimmedInput.length === 1) {
            setFilteredRfqList(allRfqList);
            setVisibleColumns(defaultVisibleColumns);
            return;
        }
    
        // Find matching columns dynamically (case-insensitive partial match)
        const matchedColumns = Object.keys(columnKeyMap).filter(col =>
            col.toLowerCase().includes(input.toLowerCase())
        );
    
        if (matchedColumns.length === 0) {
            console.warn(`No columns match "${input}"`);
            return;
        }
    
        // If multiple columns match, let the user pick or show all matches

        const filtered = allRfqList.map(item => {
            let filteredData = { email: item.email }; // Always include Product ID
        
            matchedColumns.forEach(column => {
                const columnKey = columnKeyMap[column];
                filteredData[columnKey] = item[columnKey] || "-"; // Add all matched columns
            });
        
            return filteredData;
        });
        
        setFilteredRfqList(filtered);
        setVisibleColumns(["Buyer / Seller", ...matchedColumns]); // Show all matching columns
                
    };

   const [columnSortOrder, setColumnSortOrder] = useState({}); // Track sorting order per column

    const handleOrder = (col) => {
        const fieldName = columnKeyMap[col]; 
        const newOrder = columnSortOrder[col] === "desc" ? "asc" : "desc";
        
        const sortedList = [...filteredRfqList].sort((a, b) => {
            const valueA = a[fieldName]?.toString().toLowerCase() || "";
            const valueB = b[fieldName]?.toString().toLowerCase() || "";
    
            if (!isNaN(valueA) && !isNaN(valueB)) { 
                // Numeric sorting
                return newOrder === "asc" ? valueA - valueB : valueB - valueA;
            } else {
                // String sorting
                return newOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
            }
        });
    
        setFilteredRfqList(sortedList);
        setColumnSortOrder((prev) => ({ ...prev, [col]: newOrder }));
    };

    const handleChangePage = async (condition) => {
        if (condition === 'previous') {
            if (previousPageLink) {
                const params = { page: pageCount - 1 }
                try {
                    const response = await AllRfqPagination("GET", { params });
                    setAllRfqList(response.data.results);
                    setFilteredRfqList(response.data.results);
                    setNextPageLink(response.data.links.next);
                    setPreviousPageLink(response.data.links.previous);
                } catch (error) {
                    console.error(error);
                }
                setPageCount(pageCount - 1)
            }
        } else if (condition === 'next') {
            if (nextPageLink) {
                const params = { page: pageCount + 1 }
                try {
                    const response = await AllRfqPagination("GET", { params });
                    setAllRfqList(response.data.results);
                    setFilteredRfqList(response.data.results);
                    setNextPageLink(response.data.links.next)
                    setPreviousPageLink(response.data.links.previous)
                } catch (error) {
                    console.error(error);
                }
                setPageCount(pageCount + 1)
            }
        }
    }

    useEffect(() => {
            if (onPageSize) {
                setPageSize(onPageSize)
                const fetchRfq = async () => {
                    const params = { page_size: onPageSize };
                    try {
                        const response = await AllRfqPagination("GET", { params });
                        setAllRfqList(response.data.results);
                        setFilteredRfqList(response.data.results);
                        setNextPageLink(response.data.links.next);
                        setPreviousPageLink(response.data.links.previous);
                    } catch (error) {
                        console.error("Error fetching paginated products:", error);
                    }
                };
    
                fetchRfq();
                setPageCount(1); // Prevents negative page count
            }
        }, [onPageSize]); // Added dependency on `onPageSize`
    
        const handlePageSize = async(value) => {
            setPageSize(Number(value))
            if (pageSize) {
                const fetchRfq = async () => {
                    const params = { page_size: Number(value) };
                    try {
                        const response = await AllProductsPagination("GET", { params });
                        setAllRfqList(response.data.results);
                        setFilteredRfqList(response.data.results);
                        setNextPageLink(response.data.links.next);
                        setPreviousPageLink(response.data.links.previous);
                    } catch (error) {
                        console.error("Error fetching paginated products:", error);
                    }
                };
    
                fetchRfq();
                setPageCount(1); // Prevents negative page 
                onReturnPageSize(Number(value))
            }
        }

    useEffect(() => {
        getAllRfqList();
        setPageSize(20)
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        getAllRfqList();
        setPageCount(1)
        setNextPageLink(null)
        setPreviousPageLink(null)
    }, [onRefresh]);


    useEffect(() => {
        if (onRfqSelectColumns && onRfqSelectColumns.length > 0) {
            setVisibleColumns(onRfqSelectColumns);
        } else {
            setVisibleColumns(defaultVisibleColumns);
        }
    }, [onRfqSelectColumns]);

    useEffect(() => {
        if (onSuccess) {
            getAllRfqList()
            setRfqSelectedIds([])
        }
        setPageCount(1)
        setNextPageLink(null)
        setPreviousPageLink(null)
        setShowSingleRfq(false)
    }, [onSuccess])

    useEffect(() => {
        if (onRfqColumnSearch && typeof onRfqColumnSearch === "string") {
            onRfqSearchColumn(onRfqColumnSearch);
        }
    }, [onRfqColumnSearch]);

    return (
        <>
            <div className={`overflow-scroll mx-7 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-default'}`}>
                <table className="min-w-full table-auto border-collapse">
                    <thead className="border border-gray-300 bg-gray-100">
                        <tr className="">
                            <th>
                                <input
                                    type="checkbox"
                                    className="scale-125 border border-gray-300"
                                    checked={filteredRfqList.length > 0 && selectedIds.length === filteredRfqList.length}
                                    onChange={handleSelectAll}
                                />
                            </th>
                            {visibleColumns.map((col) => (
                                <th key={col} className="w-fit text-center border border-gray-300 px-4 py-2 text-gray-600 whitespace-nowrap ">
                                    {col} &nbsp; <span
                                        key={col}
                                        className="px-2 py-0.5 font-bold border bg-white rounded-lg hover:bg-gray-300 cursor-pointer"
                                        onClick={() => handleOrder(col)}>{columnSortOrder[col] === 'desc' ? "\u2191" : "\u2193"}</span>
                                </th>
                            ))}
                            <th className="w-fit text-center border border-gray-300 px-4 py-2 text-gray-600">Actions</th>
                        </tr>
                        <tr className="bg-[#F7F7F7]">
                            <td className="border border-gray-300 px-4 py-2"></td>
                            {visibleColumns.map((col) => (
                                <td key={`search-${col}`} className="px-4 py-2 border border-gray-300 w-full">
                                    <input
                                        type="text"
                                        className="border border-gray-300 rounded-2xl px-3 outline-none"
                                        placeholder={`Search ${col}...`}
                                        onChange={(e) => handleSearch(col, e.target.value)}
                                    />
                                </td>
                            ))}
                            <td className="px-4 py-2 border border-gray-300"></td>
                        </tr>
                    </thead>
                    <tbody className="text-[14px] text-[#333]">
                        {loading ? (
                            <tr>
                                <td colSpan={visibleColumns.length + 2} className="text-center py-4 text-xl font-bold text-gray-500">
                                    Fetching Data...
                                </td>
                            </tr>
                        ) : (
                            filteredRfqList.map((item) => (
                                <tr key={item.id} className="hover:bg-gray-100">
                                    <td className="border border-gray-300 px-4 py-2 text-center">
                                        <input
                                            type="checkbox"
                                            className={`scale-125 border border-gray-300 ${onChangeIcon === 'Edit'? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'}`}
                                            checked={selectedIds.includes(item.p_id)}
                                            onChange={() => handleSelectItem(item.p_id)}
                                        />
                                    </td>
                                    {visibleColumns.map((col) => (
                                        <td key={col} className={`border border-gray-300 px-4 py-2 ${onChangeIcon === 'Edit'? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'} text-center`}
                                            onClick={() => handleRfqClick(item.id)}>
                                            {col === "Negotiable"
                                                ? item[columnKeyMap[col]] === true
                                                ? <div className="flex justify-center"><p className="text-green-600 px-3 py-1 bg-green-200 w-fit rounded-lg">Negotiable</p></div>
                                                : <div className="flex justify-center"><p className="text-red-600 px-3 py-1 bg-red-200 w-fit rounded-lg">Not Negotiable</p></div>
                                                :(item[columnKeyMap[col]] || "-")}
                                        </td>
                                    ))}
                                    <td className="border border-gray-300 px-4 py-2 text-center">
                                        <span
                                            className={`${onChangeIcon === 'Edit'? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'}`}
                                            onClick={(event) => handleIconClick(item.id, event)}
                                        >
                                            <FontAwesomeIcon icon={faEllipsisVertical} />
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            {/* Pagination */}
            <div className="flex items-center justify-center mt-5">
                <div className={`flex items-center gap-6 `}>
                    <button className={`text-white px-4 py-1 rounded-lg ${previousPageLink ? "bg-sky-500 hover:bg-sky-300" : "bg-gray-500 opacity-50 cursor-not-allowed"}`}
                        disabled={!previousPageLink}
                        onClick={() => handleChangePage('previous')}>
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </button>
                    <p className="font-bold">{pageCount}</p>
                    <button className={`text-white px-4 py-1 rounded-lg ${nextPageLink ? "bg-sky-500 hover:bg-sky-300" : "bg-gray-500 opacity-50 cursor-not-allowed"}`}
                        disabled={!nextPageLink}
                        onClick={() => handleChangePage('next')}>
                        <FontAwesomeIcon icon={faAngleRight} />
                    </button>
                </div>
            </div>

            {/* Pagination */}
            <div className={`border border-gray-300 border-collapse rounded-lg text-gray-500 flex items-center w-fit mx-7 ${onChangeIcon === 'Edit'? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'}`}>
                <div className={`py-1 px-2 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} border-r border-gray-300 ${pageSize === 20 ? 'bg-blue-600 text-white rounded-l-lg' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>20</div>
                <div className={`py-1 px-2 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} border-r border-gray-300 ${pageSize === 100 ? 'bg-blue-600 text-white' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>100</div>
                <div className={`py-1 px-2 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} border-r border-gray-300 ${pageSize === 500 ? 'bg-blue-600 text-white' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>500</div>
                <div className={`py-1 px-2 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} border-r border-gray-300 ${pageSize === 2500 ? 'bg-blue-600 text-white' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>2500</div>
                <div className={`py-1 px-2 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} ${pageSize === 5000 ? 'bg-blue-600 text-white rounded-r-lg' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>5000</div>
            </div>
            {showPopup && (
                <div ref={popupRef} style={{ position: "absolute", top: `${popupPosition.y}px`, left: `${popupPosition.x}px`, zIndex: 10 }}>
                    <TableActionPopUp RfqId={selectedId} 
                                        onSuccess={() => setShowPopup(false)} 
                                        onRfqSingleView={handleViewSingleRfq} 
                                        onRfqSuccess={handleRfqSuccess}
                                        onRfqEditSingleView={onUpdate}/>
                </div>)}

            {showSingleRfq && <SingleRfqView onId={selectedSingleRfq} onClose={()=>{setShowSingleRfq(false);setSelectedSingleRfq(null)}} onUpdate={onUpdate}/>}
        </>
    )
}
